import React, { FC } from "react";

import { DocumentTextRegular } from "@fluentui/react-icons";
import { makeStyles, tokens } from "@fluentui/react-components";

import { translate } from "@/utils/translations";
import { DocumentStatus } from "@/pages/Thread/types";

interface ContextIndicatorProps {
  contextText: string;
  documentStatus?: DocumentStatus;
}

export const ContextIndicator: FC<ContextIndicatorProps> = ({
  contextText,
  documentStatus,
}) => {
  const styles = useStyles();

  return (
    <div
      className={`${styles.contextContainer} ${
        documentStatus !== "finished" && documentStatus !== "partiallyDone"
          ? styles.contextContainerGray
          : ""
      }`}
    >
      <DocumentTextRegular className={styles.contextIcon} />
      <span>{translate(contextText)}</span>
    </div>
  );
};

const useStyles = makeStyles({
  contextContainer: {
    alignItems: "center",
    border: "1px solid #D1D1D1",
    borderRadius: "4px",
    display: "flex",
    fontSize: "12px",
    padding: "2px 4px",
  },
  contextContainerGray: {
    backgroundColor: tokens.colorNeutralBackground4,
  },
  contextIcon: {
    fontSize: "16px",
    margin: "0 4px",
  },
});
